import type {PreparedBlock} from './document'

export type SourceChunkLayout = Pick<PreparedBlock, 'anchor' | 'displayStart' | 'lineNumbers'>

export function lineStarts(lines: readonly string[]) {
  let offset = 0
  return lines.map(line => {
    const start = offset
    offset += line.length + 1
    return start
  })
}

/** Original-line buckets are shared by unmeasured SSR text and worker-prepared views. */
export function sourceChunks(lineNumbers: readonly number[], linesPerChunk: number): SourceChunkLayout[] {
  if (!Number.isSafeInteger(linesPerChunk) || linesPerChunk <= 0) {
    throw new RangeError('linesPerChunk must be a positive safe integer')
  }
  const groups = new Map<number, {lineNumbers: number[]; displayStart: number}>()
  for (const [displayStart, line] of lineNumbers.entries()) {
    const anchor = Math.floor(line / linesPerChunk) * linesPerChunk
    let group = groups.get(anchor)
    if (!group) {
      group = {lineNumbers: [], displayStart}
      groups.set(anchor, group)
    }
    group.lineNumbers.push(line)
  }
  if (!groups.size) groups.set(0, {lineNumbers: [], displayStart: 0})
  return [...groups].map(([anchor, group]) => ({anchor, ...group}))
}
